import { observer } from 'mobx-react-lite';
import { PopulatedExperienceTag } from '@/schemas/experience-tag-schema.ts';
import QuickData from '@components/data/quick-data/quick-data.tsx';
import ViewPanel from '@components/view/view-panel.tsx';
import calculateAverage from '@utils/calculate-average.ts';
import ClassString from '@utils/class-string.ts';

interface ExperienceTagDetailsAveragesProps {
	tag: PopulatedExperienceTag;
}

const ExperienceTagDetailsAverages = observer(
	function ExperienceTagDetailsAverages(
		props: ExperienceTagDetailsAveragesProps
	) {
		const averagePlayers = calculateAverage(
			props.tag.places.map((exp) => exp.players_online ?? 0),
			true
		);

		const averageVisits = calculateAverage(
			props.tag.places.map((exp) => exp.total_visits ?? 0),
			true
		);

		const averageFavorites = calculateAverage(
			props.tag.places.map((exp) => exp.favorites ?? 0),
			true
		);

		const averageLikeRate =
			calculateAverage(
				props.tag.places.map((exp) => exp.like_percentage ?? 0)
			) * 100;

		return (
			<div
				className={ClassString({
					static: 'gap-6 grid sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 w-full lg:w-panel-1/2 grid-rows-[auto_1fr_1fr_1fr_1fr] sm:grid-rows-[auto_1fr_1fr] lg:grid-rows-[auto_1fr_1fr_1fr_1fr] xl:grid-rows-[auto_1fr_1fr]',
					dynamic: {},
				})}
			>
				<div
					className={
						'text-md sm:text-2xl sm:col-span-2 lg:col-span-1 xl:col-span-2 w-fit -mb-2'
					}
				>
					{'Tag Averages'}
				</div>

				<ViewPanel
					className={'justify-center'}
					options={{
						centerContent: true,
					}}
				>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							averagePlayers
						)}
						title={'Average Players Online'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel
					className={'justify-center'}
					options={{
						centerContent: true,
					}}
				>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							averageVisits
						)}
						title={'Average Visits'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel
					className={'justify-center'}
					options={{
						centerContent: true,
					}}
				>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							averageFavorites
						)}
						title={'Average Favorites'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel
					className={'justify-center'}
					options={{
						centerContent: true,
					}}
				>
					<QuickData
						className={'m-0'}
						data={`${averageLikeRate.toFixed(2)}%`}
						title={'Average Like Rate'}
						size={'small'}
					/>
				</ViewPanel>
			</div>
		);
	}
);

export default ExperienceTagDetailsAverages;
